  import React from "react";

  export default function PlayBackSpeed({ setPlayBackSpeed }) {

    return (
      <select
        className="form-select history-playback-speed cursor"
        onChange={(e) => setPlayBackSpeed(e.target.value)}
        dir="ltr"
      >
        <option className="cursor" value="1">
          x1{" "}
        </option>
        <option className="cursor" value="0.75">
          x1.5{" "}
        </option>
        <option className="cursor" value="0.5">
          x2{" "}
        </option>
      </select>
    );
  }
